import {
  Box,
  Typography,
  Grid,
  Button,
  IconButton,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Divider,
} from "@material-ui/core";
import {
  DeleteForever,
  Edit,
  FiberManualRecord,
  Clear,
  AccountBalanceWallet,
  CalendarToday,
  Info,
  Update,

} from "@material-ui/icons";
import { useEffect, useState } from "react";
import PlanChangeDialog from "../../PlanDetails/SubscriptionPlans/PlanChangeDialog";
import WccChangeDialog from "../../PlanDetails/WccPlans/WccChangeDialog";
import moment from "moment";
import axios from "axios";
import {
  URL,
  partnerURL,
} from "../../../config/config";
import ConfirmationDialog from "../ConfirmationDialog";
import { Autocomplete } from "@material-ui/lab";
import WhatsappPaymentsChangeDialog from "../../PlanDetails/WhatsappPaymentsPlans/WhatsappPaymentsChangeDialog";
import { checkAccess } from "../../../helpers/RBAC";
import { isTrialPlan, humanisePlanKey } from "../../../helpers/planLabel";

export default function PlanSetup(props) {
  const [dialog, setDialog] = useState();
  const [loader, setLoader] = useState();
  const [amount, setAmount] = useState();
  const [action, setAction] = useState("ADD");
  const [projectStatus, setProjectStatus] = useState();
  const [pendingPlanChange, setPendingPlanChange] = useState(null);
  const [planCostData, setPlanCostData] = useState(null);

  const {
    classes,
    partner,
    planFamilies,
    wccPlans,
    whatsappPaymentPlans,
    assistant,
    setSnackbar,
    modifyAssistant,
    setAssistant,
    history,
    partnerAgents,
    user,
  } = props;

  const {
    isWhatsappVerified,
    activePlan,
    templateTier,
    paymentPlanId,
    familyId,
  } = assistant;

  const { type, addons: partnerAddons } = partner;

  const hasReadAccess = checkAccess(
    partner,
    partnerAgents,
    user,
    "business",
    "read"
  );

  const hasWriteAccess = checkAccess(
    partner,
    partnerAgents,
    user,
    "business",
    "write"
  );

  const toggleDialog = (key) => {
    if (dialog === key) {
      key = undefined;
    }
    setDialog(key);
  };

  useEffect(() => {
    setProjectStatus(assistant?.status);
  }, []);

  const executePlanChange = async (newFamilyId, newPlanId) => {
    // If called from the confirmation dialog, use the pending state
    const familyIdToUse = newFamilyId || pendingPlanChange?.newFamilyId;
    const planIdToUse = newPlanId || pendingPlanChange?.newPlanId;

    if (!familyIdToUse || !planIdToUse) {
      setSnackbar({
        alert: true,
        alertType: "error",
        alertMsg: "Invalid plan details",
      });
      return;
    }

    const newObj = { ...assistant };
    try {
      const response = await axios.patch(
        partnerURL +
        `/partner/${assistant.partnerId}/project/${assistant._id}/billing/switch-plan`,
        {
          newFamilyId: familyIdToUse,
          newPlanId: planIdToUse,
        }
      );

      if (response.status === 200) {
        newObj.activePlan = planIdToUse;
        newObj.familyId = familyIdToUse;
        modifyAssistant(newObj._id, "familyId", familyIdToUse);
        modifyAssistant(newObj._id, "activePlan", planIdToUse);
        setAssistant(newObj);

        setSnackbar({
          alert: true,
          alertType: "success",
          alertMsg: response.data.message || "Successfully updated plan",
        });
        // Close both potentially open dialogs (though only ConfirmPlanCost should be open at this point)
        toggleDialog("ChangeSubscriptionPlan");
        toggleDialog("ConfirmPlanCost");
        setPendingPlanChange(null);
        setPlanCostData(null);
      }
    } catch (error) {
      setSnackbar({
        alert: true,
        alertType: "error",
        alertMsg:
          error?.response?.data?.message || "something went wrong, try again",
      });
    }
  };

  const initiatePlanChange = async (newFamilyId, newPlanId) => {
    setLoader(true);
    try {
      const response = await axios.post(
        partnerURL +
        `/partner/${assistant.partnerId}/project/${assistant._id}/billing/switch-plan-cost`,
        {
          newFamilyId,
          newPlanId,
        }
      );

      setPlanCostData(response.data);
      setPendingPlanChange({ newFamilyId, newPlanId });
      toggleDialog("ChangeSubscriptionPlan"); // Close the selection dialog
      toggleDialog("ConfirmPlanCost"); // Open the confirmation dialog
    } catch (error) {
      setSnackbar({
        alert: true,
        alertType: "error",
        alertMsg:
          error?.response?.data?.message || "Failed to fetch plan cost information",
      });
    } finally {
      setLoader(false);
    }
  };

  // For Trial Expired users who didn't made their api live
  const changeProjectStatus = async () => {
    const newObj = { ...assistant };
    try {
      const response = await axios.put(URL + "/api/change-project-status", {
        status: projectStatus,
        assistantId: newObj._id,
        partnerId: newObj.partnerId,
      });
      if (response.status == 200) {
        modifyAssistant(assistant._id, "status", projectStatus);
        setAssistant(newObj);
        setSnackbar({
          alert: true,
          alertType: "success",
          alertMsg: response.data.message || "Successfully changed",
        });
        toggleDialog("EmbeddedSignup");
      }
    } catch (error) {
      setSnackbar({
        alert: true,
        alertType: "error",
        alertMsg:
          error?.response?.data?.message || "something went wrong, try again",
      });
      setProjectStatus(assistant?.status);
      toggleDialog("EmbeddedSignup");
    }
  };

  const changeWccPlan = async (wccPlanId) => {
    const newObj = { ...assistant };
    try {
      const response = await axios.patch(URL + "/api/update-project-wcc-plan", {
        assistantId: assistant._id,
        wccPlanId,
      });

      if (response.status === 200) {
        newObj.templateTier = wccPlanId;
        modifyAssistant(newObj._id, "templateTier", wccPlanId);
        setAssistant(newObj);
        setSnackbar({
          alert: true,
          alertType: "success",
          alertMsg: response.data.message || "Successfully changed wcc plan",
        });
        toggleDialog("ChangeWccPlan");
      }
    } catch (error) {
      setSnackbar({
        alert: true,
        alertType: "error",
        alertMsg:
          error?.response?.data?.message || "something went wrong, try again",
      });
    }

    setLoader(false);
  };

  const changeWhatsappPaymentsPlan = async (paymentPlanId) => {
    const newObj = { ...assistant };
    try {
      const response = await axios.patch(
        URL + "/api/whatsapp-payments-plans/set-plan",
        {
          assistantId: assistant._id,
          paymentPlanId,
        }
      );

      if (response.status === 200) {
        newObj.paymentPlanId = paymentPlanId;
        modifyAssistant(newObj._id, "paymentPlanId", paymentPlanId);
        setAssistant(newObj);
        setSnackbar({
          alert: true,
          alertType: "success",
          alertMsg: response.data.message || "Successfully changed wcc plan",
        });
        toggleDialog("ChangeWhatsappPaymentsPlan");
      }
    } catch (error) {
      setSnackbar({
        alert: true,
        alertType: "error",
        alertMsg:
          error?.response?.data?.message || "something went wrong, try again",
      });
    }

    setLoader(false);
  };

  const deleteProject = async () => {
    setLoader(true);
    await axios
      .post(URL + `/api/delete-project/${assistant._id}`)
      .then((response) => {
        if (response.data.status === "#28C153") {
          const data = { projectDeleted: true };
          history.push("/assistants", data);
        }

        throw { response: { data: { message: response.data.message } } };
      })
      .catch((error) => {
        setSnackbar({
          alert: true,
          alertType: "error",
          alertMsg: error?.response?.data?.message || "something went wrong",
        });
      });

    setLoader(false);
    toggleDialog("DeleteProject");
  };

  const reactivatePlan = async () => {
    setLoader(true);
    const newObj = { ...assistant };
    const {
      familyId,
      activePlan: defaultPlan,
      partnerId,
      _id: assistantId,
    } = assistant;

    await axios
      .patch(
        partnerURL +
        `/partner/${partnerId}/project/${assistantId}/billing/reactivate-project`,
        { familyId, defaultPlan }
      )
      .then((response) => {
        newObj.planStoppedOn = false;
        modifyAssistant(newObj._id, "planStoppedOn", false);
        setAssistant(newObj);
        setSnackbar({
          alert: true,
          alertType: "success",
          alertMsg: response.data.message || "plan reactivated Successfully",
        });
        toggleDialog("ReactivatePlan");
      })
      .catch((error) => {
        setSnackbar({
          alert: true,
          alertType: "error",
          alertMsg: error?.response?.data?.message || "something went wrong",
        });
      });

    setLoader(false);
  };

  const stopPlan = async () => {
    setLoader(true);
    await axios
      .patch(
        partnerURL +
        `/partner/${assistant.partnerId}/stop-project-billing/${assistant._id}`
      )
      .then((response) => {
        setSnackbar({
          alert: true,
          alertType: "success",
          alertMsg: response?.data?.message || "Plan Stopped!",
        });
        toggleDialog("StopPlan");
      })
      .catch((error) => {
        console.log(error);
        setSnackbar({
          alert: true,
          alertType: "error",
          alertMsg: error?.response?.data?.message || "something went wrong",
        });
      });

    setLoader(false);
  };

  const updateCredits = async (type, amount, action) => {
    setLoader(true);
    const newObj = { ...assistant };
    if (amount > 0 && ["ADD", "SUBTRACT"].includes(action)) {
      await axios
        .patch(
          partnerURL +
          `/partner/${assistant.partnerId}/project/${assistant._id}/billing/${type}`,
          {
            amount,
            action,
          }
        )
        .then(({ data }) => {
          if (type !== "adCredit") {
            const key =
              type === "pwc" ? "partnerWhatsappCredit" : "templateCredit";
            const credit = data.credit + amount;

            newObj[key] = credit;

            modifyAssistant(newObj._id, key, credit);
            setAssistant(newObj);
          } else {
            props.fecthAssistant();
          }

          setSnackbar({
            alert: true,
            alertType: "success",
            alertMsg: data?.message || "Successfully updated!",
          });

          toggleDialog(
            type === "adCredit"
              ? "adCredit"
              : type === "pwc"
                ? "PwcCredit"
                : "WccCredit"
          );
        })
        .catch((error) => {
          setSnackbar({
            alert: true,
            alertType: "error",
            alertMsg: error?.response?.data?.message || "something went wrong",
          });
        });
    } else {
      setSnackbar({
        alert: true,
        alertType: "error",
        alertMsg: "Invalid Amount",
      });
    }

    setLoader(false);
  };

  /* Helper to get plan name from ID */
  const getPlanName = (planId) => {
    // A trial is not a key in any priced plan family, so resolve it first —
    // otherwise the lookup misses and the raw key leaks to the UI (PTR-40).
    if (isTrialPlan(planId)) return humanisePlanKey(planId);
    if (!planId || !planFamilies) return "Unknown Plan";
    const families = Object.values(planFamilies);
    for (const family of families) {
      if (family.plans && family.plans[planId]) {
        return family.plans[planId].name;
      }
    }
    return planId;
  };

  return (
    <Box>
      {/*
       * Project Config
       */}
      {isWhatsappVerified ? (
        <VerifiedProjectConfig
          partnerType={type}
          subscriptionPlanFamilies={planFamilies}
          wccPlanFamilies={wccPlans}
          whatsappPaymentPlans={whatsappPaymentPlans}
          partnerId={partner._id}
          toggleDialog={toggleDialog}
          assistant={assistant}
          loader={loader}
          classes={classes}
          hasReadAccess={hasReadAccess}
          hasWriteAccess={hasWriteAccess}
          partnerAddons={partnerAddons}
        />
      ) : (
        <UnverifiedProjectConfig
          deleteProject={() => toggleDialog("DeleteProject")}
          toggleEmbeddedSignup={() => toggleDialog("EmbeddedSignup")}
          projectStatus={projectStatus}
          classes={classes}
          hasWriteAccess={hasWriteAccess}
          toggleDialog={toggleDialog}
          assistant={assistant}
          partner={partner}
        />
      )}

      {/*
       * Popup Dialogs Section
       */}
      {dialog === "ChangeSubscriptionPlan" && (
        <PlanChangeDialog
          classes={classes}
          showDialog={true}
          toggleDialog={() => toggleDialog("ChangeSubscriptionPlan")}
          planFamilies={planFamilies}
          changePlan={initiatePlanChange}
          defaultPlanFamily={familyId}
          defaultPlanName={activePlan}
        />
      )}
      {dialog === "ConfirmPlanCost" && planCostData && (
        <ConfirmationDialog
          openDialog={true}
          closeDialog={() => {
            toggleDialog("ConfirmPlanCost");
            setPendingPlanChange(null);
            setPlanCostData(null);
          }}
          classes={classes}
          action={() => executePlanChange()}
          title={"Confirm Plan Change"}
          loader={loader}
          body={
            <Box style={{ backgroundColor: "#ffffff" }}>
              {/* Header Alert */}
              <Box display="flex" alignItems="center" marginBottom="20px">
                <Info style={{ color: "#5c2e91", marginRight: "8px" }} />
                <Typography
                  variant="body1"
                  style={{
                    color: "#1f2937",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  Are you sure you want to switch to this plan?
                </Typography>
              </Box>

              {/* Details Card */}
              <Box
                style={{
                  backgroundColor: "#f9fafb",
                  borderRadius: "8px",
                  padding: "10px",
                  border: "1px solid #f3f4f6",
                  marginBottom: "24px",
                }}
              >
                <Grid container spacing={2}>
                  {/* Active Plan */}
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px dashed #e5e7eb",
                      paddingBottom: "8px",
                    }}
                  >
                    <Typography variant="body2" style={{ color: "#6b7280" }}>
                      Active Plan
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ color: "#111827", fontWeight: 500 }}
                    >
                      {getPlanName(assistant?.activePlan)}
                    </Typography>
                  </Grid>

                  {/* New Plan */}
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px dashed #e5e7eb",
                      paddingBottom: "8px",
                      paddingTop: "8px",
                    }}
                  >
                    <Typography variant="body2" style={{ color: "#6b7280" }}>
                      New Plan
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ color: "#5c2e91", fontWeight: 600 }}
                    >
                      {getPlanName(pendingPlanChange?.newPlanId)}
                    </Typography>
                  </Grid>

                  {/* Old Plan Start Date */}
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px dashed #e5e7eb",
                      paddingBottom: "8px",
                      paddingTop: "8px",
                    }}
                  >
                    <Typography variant="body2" style={{ color: "#6b7280" }}>
                      Old plan start date
                    </Typography>
                    <Box display="flex" alignItems="center">
                      <CalendarToday
                        style={{
                          fontSize: "16px",
                          color: "#9ca3af",
                          marginRight: "6px",
                        }}
                      />
                      <Typography
                        variant="body2"
                        style={{ color: "#111827", fontWeight: 500 }}
                      >
                        {moment(planCostData?.prevPlanConfig?.prevTermStart).format(
                          "DD MMM YYYY"
                        )}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* New Plan Start Date */}
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px dashed #e5e7eb",
                      paddingBottom: "8px",
                      paddingTop: "8px",
                    }}
                  >
                    <Typography variant="body2" style={{ color: "#6b7280" }}>
                      New plan start date
                    </Typography>
                    <Box display="flex" alignItems="center">
                      <CalendarToday
                        style={{
                          fontSize: "16px",
                          color: "#9ca3af",
                          marginRight: "6px",
                        }}
                      />
                      <Typography
                        variant="body2"
                        style={{ color: "#111827", fontWeight: 500 }}
                      >
                        {moment(planCostData?.newPlanConfig?.newTermStart).format(
                          "DD MMM YYYY"
                        )}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Renewal Date */}
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingTop: "8px",
                    }}
                  >
                    <Typography variant="body2" style={{ color: "#6b7280" }}>
                      Renewal date
                    </Typography>
                    <Box display="flex" alignItems="center">
                      <Update
                        style={{
                          fontSize: "16px",
                          color: "#9ca3af",
                          marginRight: "6px",
                        }}
                      />
                      <Typography
                        variant="body2"
                        style={{ color: "#111827", fontWeight: 500 }}
                      >
                        {moment(planCostData?.newPlanConfig?.newTermEnd).format(
                          "DD MMM YYYY"
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              {/* Cost Breakdown */}
              <Box margin="24px 6px">
                {/* New Plan Charges */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  marginBottom="12px"
                >
                  <Typography variant="body2" style={{ color: "#4b5563" }}>
                    New plan charges
                  </Typography>
                  <Typography
                    variant="body2"
                    style={{ color: "#ef4444", fontWeight: 500 }}
                  >
                    {partner?.currency === "USD" ? "$" : "₹"}{" "}
                    {(
                      (planCostData?.newPlanConfig?.newPlanCharges || 0) / 100000
                    ).toFixed(2)}
                  </Typography>
                </Box>

                {/* Old Plan Refundable */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  marginBottom="12px"
                >
                  <Typography variant="body2" style={{ color: "#4b5563" }}>
                    Old plan refundable amount{" "}
                    <span style={{ fontSize: "12px", color: "#9ca3af" }}>
                      ({planCostData?.prevPlanConfig?.remainingDays} days remaining)
                    </span>
                  </Typography>
                  <Typography
                    variant="body2"
                    style={{ color: "#047857", fontWeight: 500 }}
                  >
                    {partner?.currency === "USD" ? "$" : "₹"}{" "}
                    {(
                      (planCostData?.prevPlanConfig?.refundableAmount || 0) / 100000
                    ).toFixed(2)}
                  </Typography>
                </Box>

                {/* Flow Charges */}
                {planCostData?.flowConfig?.flowChargeableAmount !== 0 && (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    marginBottom="12px"
                  >
                    <Typography variant="body2" style={{ color: "#4b5563" }}>
                      New flow charges
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ color: "#ef4444", fontWeight: 500 }}
                    >
                      {partner?.currency === "USD" ? "$" : "₹"}{" "}
                      {(
                        (planCostData?.flowConfig?.newFlowCharge || 0) / 100000
                      ).toFixed(2)}
                    </Typography>
                  </Box>
                )}

                {/* Flow Refundable */}
                {planCostData?.flowConfig?.flowChargeableAmount !== 0 && (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    marginBottom="12px"
                  >
                    <Typography variant="body2" style={{ color: "#4b5563" }}>
                      Flow refundable amount
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ color: "#047857", fontWeight: 500 }}
                    >
                      {partner?.currency === "USD" ? "$" : "₹"}{" "}
                      {(
                        (planCostData?.flowConfig?.refundableAmount || 0) / 100000
                      ).toFixed(2)}
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Total Amount Box */}
              <Box
                style={{
                  backgroundColor:
                    planCostData.newChargeableAmount >= 0
                      ? "#fef2f2"
                      : "#ecfdf5", // Keeping green background for refundable logic or change as needed. Based on design it seemed green.
                  border: planCostData.newChargeableAmount >= 0 ? "0.5px solid #fecaca" : "0.5px solid #a7f3d0",
                  borderRadius: "8px",
                  padding: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Box
                  style={{
                    backgroundColor: planCostData.newChargeableAmount >= 0 ? "#ffd7d7ff" : "#D1FAE6",
                    padding: "8px",
                    borderRadius: "50%",
                    display: "flex",
                    marginRight: "16px",
                  }}
                >
                  <AccountBalanceWallet
                    style={{ color: planCostData.newChargeableAmount >= 0 ? "#ef4444" : "#059669", fontSize: "24px" }}
                  />
                </Box>
                <Box style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  <Typography
                    variant="caption"
                    style={{
                      color: planCostData.newChargeableAmount >= 0 ? "#ef4444" : "#059669",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}
                  >
                    {planCostData.newChargeableAmount >= 0
                      ? "Chargeable Amount"
                      : "Refundable Amount"}
                  </Typography>
                  <Typography
                    variant="h3"
                    style={{
                      color: "#111827",
                      fontWeight: 700,
                      lineHeight: 1,
                      marginTop: "4px",
                    }}
                  >
                    {partner?.currency === "USD" ? "$" : "₹"}{" "}
                    {(
                      Math.abs(planCostData.newChargeableAmount) / 100000
                    ).toFixed(2)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          }
        />
      )}
      {dialog === "ChangeWccPlan" && (
        <WccChangeDialog
          classes={classes}
          showDialog={true}
          toggleDialog={() => toggleDialog("ChangeWccPlan")}
          wccPlans={wccPlans}
          defaultPlan={templateTier}
          changePlan={changeWccPlan}
        />
      )}
      {dialog === "ChangeWhatsappPaymentsPlan" && (
        <WhatsappPaymentsChangeDialog
          classes={classes}
          showDialog={true}
          toggleDialog={() => toggleDialog("ChangeWhatsappPaymentsPlan")}
          plans={whatsappPaymentPlans}
          defaultPlan={paymentPlanId}
          changePlan={changeWhatsappPaymentsPlan}
        />
      )}
      {dialog === "DeleteProject" && (
        <ConfirmationDialog
          openDialog={true}
          closeDialog={() => toggleDialog("DeleteProject")}
          classes={classes}
          action={deleteProject}
          title={"Archive Project"}
          loader={loader}
          body={
            <Typography
              variant="body1"
              style={{ color: "black" }}
              display="inline"
            >
              Are you sure that you want to archive this project?
            </Typography>
          }
        />
      )}
      {dialog === "ReactivatePlan" && (
        <ConfirmationDialog
          openDialog={true}
          closeDialog={() => toggleDialog("ReactivateProject")}
          classes={classes}
          action={reactivatePlan}
          title={"Reactivate Project"}
          loader={loader}
          body={
            <Typography
              variant="body1"
              style={{ color: "black" }}
              display="inline"
            >
              Are you sure that you want to reactivate this project?
            </Typography>
          }
        />
      )}
      {dialog === "StopPlan" && (
        <Dialog
          open={true}
          closeDialog={() => toggleDialog("StopPlan")}
          maxWidth={"xs"}
        >
          <Grid
            item
            container
            justifyContent="flex-end"
            xs={12}
            style={{
              height: 30,
              marginBottom: 10,
              marginTop: 4,
              alignItems: "center",
              justifyContent: "space-between",
              paddingLeft: 16,
              paddingRight: 8,
            }}
          >
            <Typography variant="h3">Stop Project</Typography>
            <IconButton onClick={() => toggleDialog("StopPlan")}>
              <Clear />
            </IconButton>
          </Grid>
          <Box
            style={{ padding: "24px 16px 16px 24px" }}
            display="flex"
            flexDirection="column"
            justifyContent="center"
          >
            <Grid container justify="center">
              <Grid item xs={12} style={{ display: "flex" }}>
                <Typography variant="h4">
                  Are you sure you want disable this project? If you disable
                  this project then all of its services will be terminated
                  permanently.
                </Typography>
              </Grid>
              <Box
                width="100%"
                height="1em"
                style={{ height: "64px", width: "48px" }}
              ></Box>
            </Grid>
            <DialogActions style={{ padding: 0 }}>
              <Button
                variant="outlined"
                size="medium"
                color="primary"
                onClick={() => toggleDialog("StopPlan")}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                size="medium"
                color="primary"
                onClick={stopPlan}
                disabled={loader}
                endIcon={loader ? <CircularProgress size={20} /> : ""}
              >
                Stop Plan
              </Button>
            </DialogActions>
          </Box>
        </Dialog>
      )}
      {dialog === "adCredit" && (
        <Dialog
          open={true}
          maxWidth="xs"
          onClose={() => toggleDialog(dialog)}
          aria-labelledby="form-dialog-title"
          className={classes.plandialogContainer}
        >
          <DialogContent>
            <Grid container spacing={2}>
              <Grid
                item
                container
                justifyContent="flex-end"
                xs={12}
                style={{ height: 30, marginBottom: 10 }}
              >
                <IconButton onClick={() => toggleDialog(dialog)}>
                  <Clear />
                </IconButton>
              </Grid>
              <Grid
                container
                style={{ alignItems: "center", marginTop: "15px" }}
              >
                <Grid item xs={12} sm={2} style={{ marginBottom: "20px" }}>
                  <Typography>action</Typography>
                </Grid>
                <Grid item xs={9} style={{ marginBottom: "20px" }}>
                  <Autocomplete
                    disableClearable
                    autoHighlight
                    options={["ADD", "SUBTRACT"]}
                    onChange={(e, value, reason) => {
                      if (reason === "select-option") {
                        setAction(value);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        InputProps={{ ...params.InputProps }}
                        placeholder="Select an action"
                        name="action"
                      />
                    )}
                    style={{ width: "calc(100%)", paddingTop: "0px" }}
                  />
                </Grid>
                <Grid item xs={12} sm={2} style={{ marginBottom: "20px" }}>
                  <Typography>Amount</Typography>
                </Grid>
                <Grid item xs={9} style={{ marginBottom: "20px" }}>
                  <TextField
                    name="amount"
                    placeholder=" Your amount here"
                    style={{ width: "100%" }}
                    InputProps={{
                      startAdornment: partner?.currency === "USD" ? "$" : "₹",
                    }}
                    onChange={(e) => {
                      const value = Number(e.target.value ?? 0);
                      if (value > 0) setAmount(value * 100000);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid item container justifyContent="flex-end" xs={12}>
              <Button
                color="primary"
                variant="contained"
                onClick={() => updateCredits("adCredit", amount, action)}
                style={{ margin: 16 }}
                disabled={loader}
                endIcon={loader ? <CircularProgress size={20} /> : ""}
              >
                Submit
              </Button>
            </Grid>
          </DialogActions>
        </Dialog>
      )}
      {["PwcCredit", "WccCredit"].includes(dialog) && (
        <Dialog
          open={true}
          maxWidth="xs"
          onClose={() => toggleDialog(dialog)}
          aria-labelledby="form-dialog-title"
          className={classes.plandialogContainer}
        >
          <DialogContent>
            <Grid container spacing={2}>
              <Grid
                item
                container
                justifyContent="flex-end"
                xs={12}
                style={{ height: 30, marginBottom: 10 }}
              >
                <IconButton onClick={() => toggleDialog(dialog)}>
                  <Clear />
                </IconButton>
              </Grid>
              <Grid
                container
                style={{ alignItems: "center", marginTop: "15px" }}
              >
                <Grid item xs={12} sm={2} style={{ marginBottom: "20px" }}>
                  <Typography>Action</Typography>
                </Grid>
                <Grid item xs={9} style={{ marginBottom: "20px" }}>
                  <Autocomplete
                    disableClearable
                    autoHighlight
                    options={["ADD", "SUBTRACT"]}
                    onChange={(e, value, reason) => {
                      if (reason === "select-option") {
                        setAction(value);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        InputProps={{ ...params.InputProps }}
                        placeholder="Select an action"
                        name="action"
                      />
                    )}
                    style={{ width: "calc(100%)", paddingTop: "0px" }}
                  />
                </Grid>
                <Grid item xs={12} sm={2} style={{ marginBottom: "20px" }}>
                  <Typography>Amount</Typography>
                </Grid>
                <Grid item xs={9} style={{ marginBottom: "20px" }}>
                  <TextField
                    name="amount"
                    placeholder=" Your amount here"
                    type="number"
                    style={{ width: "100%" }}
                    InputProps={{
                      startAdornment: partner?.currency === "USD" ? "$" : "₹",
                    }}
                    onChange={(e) => {
                      const value = Number(e.target.value ?? 0);
                      if (value > 0) setAmount(value * 100000);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid item container justifyContent="flex-end" xs={12}>
              <Button
                color="primary"
                variant="contained"
                onClick={() =>
                  updateCredits(
                    dialog === "PwcCredit" ? "pwc" : "wcc",
                    amount,
                    action
                  )
                }
                style={{ margin: 16 }}
                disabled={loader}
                endIcon={loader ? <CircularProgress size={20} /> : ""}
              >
                Submit
              </Button>
            </Grid>
          </DialogActions>
        </Dialog>
      )}
      {dialog === "EmbeddedSignup" && (
        <>
          <Dialog
            open={true}
            maxWidth="xs"
            onClose={() => toggleDialog(dialog)}
            aria-labelledby="form-dialog-title"
            className={classes.plandialogContainer}
          >
            <DialogContent>
              <Grid container spacing={2}>
                <Grid
                  item
                  container
                  justifyContent="center"
                  xs={12}
                  style={{ height: 30, fontWeight: "bold" }}
                >
                  Warning
                </Grid>
                <Grid
                  container
                  style={{
                    alignItems: "center",
                    marginTop: "15px",
                    padding: "10px 26px 0px 26px ",
                  }}
                >
                  <Grid item xs={12} sm={12} style={{ marginBottom: "20px" }}>
                    <Typography style={{ textAlign: "center" }}>
                      {projectStatus == "active"
                        ? `${"Enabling will make the dashboard and the embedded signup 'Apply' button visible. After the user completes the Facebook sign-up, default plans will be automatically assigned to the user's account, resulting in plan charges being deducted from your central balance."}`
                        : projectStatus == "stopped"
                          ? `${"Users will NOT be able to see the embedded Facebook signup button. The dashboard will be closed"}`
                          : ""}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} style={{ marginBottom: "20px" }}>
                  <Autocomplete
                    disableClearable
                    autoHighlight
                    options={["active", "stopped"]}
                    value={projectStatus}
                    onChange={(e, value, reason) => {
                      if (reason === "select-option") {
                        setProjectStatus(value);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        InputProps={{ ...params.InputProps }}
                        placeholder="Select an action"
                        name="action"
                      />
                    )}
                    style={{ width: "calc(100%)", paddingTop: "0px" }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ paddingTop: "0px" }}>
              <Grid item container justifyContent="center" xs={12}>
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={() => toggleDialog(dialog)}
                  style={{ margin: "16px 0px 16px 16px" }}
                >
                  cancel
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={changeProjectStatus}
                  style={{ margin: 16 }}
                  disabled={loader || assistant.status == projectStatus}
                  endIcon={loader ? <CircularProgress size={20} /> : ""}
                >
                  Change
                </Button>
              </Grid>
            </DialogActions>
          </Dialog>
        </>
      )}
    </Box>
  );
}

function PlanColumn(props) {
  const { title, color = "#461486" } = props;
  return (
    <Typography variant="h4" color="primary" noWrap>
      <FiberManualRecord
        style={{
          color,
          fontSize: 16,
          position: "relative",
          marginTop: 20,
          top: 3,
          right: 3,
        }}
      />
      {title}
    </Typography>
  );
}

function PlanRow(props) {
  const { title, value, showIcon, handleClick, Icon, classes, hasWriteAccess } =
    props;
  return (
    <Grid container style={{ marginBottom: "30px" }}>
      <Grid item xs={12} md={4} className={classes.cells}>
        {title}
      </Grid>
      <Grid item xs={12} md={4} className={classes.cells}>
        {value}
      </Grid>

      <Grid item xs={12} md={4} className={classes.cells}>
        {showIcon && (
          <IconButton
            style={{ marginTop: -14 }}
            disabled={!hasWriteAccess}
            onClick={handleClick}
          >
            {Icon}
          </IconButton>
        )}
      </Grid>
    </Grid>
  );
}

function ActivePlan(props) {
  const {
    title,
    activeFamily,
    activePlan,
    planStoppedOn,
    families,
    toggleDialog,
    familyType,
    isWhatsappVerified,
    classes,
    hasWriteAccess,
  } = props;

  return (
    <Box>
      <PlanColumn
        title={title}
        color={isWhatsappVerified ? "#08CF65" : "#ff8c00"}
      />
      <Box mt={2} />
      <PlanRow
        title={"Active Plan Family"}
        value={
          activeFamily ||
          (isTrialPlan(activePlan)
            ? `${humanisePlanKey(activePlan)} \u2014 no plan family until conversion`
            : "NA")
        }
        showIcon={!planStoppedOn && Object.keys(families).length >= 1}
        hasWriteAccess={hasWriteAccess}
        handleClick={() => toggleDialog(familyType)}
        Icon={<Edit />}
        classes={classes}
      />

      {activePlan && (
        <PlanRow
          title={"Active Plan"}
          value={activePlan}
          hasWriteAccess={hasWriteAccess}
          showIcon={!planStoppedOn && Object.keys(families).length >= 1}
          handleClick={() => toggleDialog(familyType)}
          Icon={<Edit />}
          classes={classes}
        />
      )}
    </Box>
  );
}

function VerifiedProjectConfig(props) {
  const {
    partnerType,
    subscriptionPlanFamilies,
    wccPlanFamilies,
    whatsappPaymentPlans,
    partnerId,
    toggleDialog,
    assistant,
    loader,
    classes,
    hasReadAccess,
    hasWriteAccess,
    partnerAddons,
  } = props;

  const {
    planRenewalOn,
    isWhatsappVerified,
    status,
    chargebeePlan,
    planStoppedOn,
    partnerWhatsappCredit,
    templateCredit,
    metaAdsCredit,
    familyId,
    templateTier,
    activePlan,
    paymentPlanId,
    currency,
    adSetupDetails,
  } = assistant;

  const subscriptionFamily = subscriptionPlanFamilies[familyId];
  const subscriptionFamilyName = subscriptionFamily?.name || "NA FAMILY";
  const subscriptionFamilyActivePlanName =
    subscriptionFamily?.plans?.[activePlan]?.name || "NA PLAN";
  const wccPlanName = wccPlanFamilies?.[templateTier]?.name ?? "NA PLAN";
  const whatsappPaymentPlanName =
    whatsappPaymentPlans?.[paymentPlanId]?.name ?? "NA PLAN";

  const { WHATSAPP_PAY, META_ADS } = partnerAddons || {};

  return (
    <Box>
      <Box padding={4}>
        {!chargebeePlan && partnerType !== "DIRECT" && hasReadAccess && (
          <>
            <ActivePlan
              title={"Subscription Plan Family"}
              activeFamily={subscriptionFamilyName}
              activePlan={subscriptionFamilyActivePlanName}
              planStoppedOn={planStoppedOn}
              families={subscriptionPlanFamilies}
              toggleDialog={() => toggleDialog("ChangeSubscriptionPlan")}
              familyType={"ChangeSubscriptionPlan"}
              isWhatsappVerified={isWhatsappVerified}
              classes={classes}
              hasWriteAccess={hasWriteAccess}
            />

            <ActivePlan
              title={"WhatsApp Conversation Charges (WCC) Family"}
              activeFamily={wccPlanName}
              planStoppedOn={planStoppedOn}
              families={wccPlanFamilies}
              toggleDialog={() => toggleDialog("ChangeWccPlan")}
              familyType={"ChangeWccPlan"}
              isWhatsappVerified={isWhatsappVerified}
              classes={classes}
              hasWriteAccess={hasWriteAccess}
            />

            {WHATSAPP_PAY?.status === "active" && (
              <ActivePlan
                title={"WhatsApp Payments Plan Family"}
                activeFamily={whatsappPaymentPlanName}
                planStoppedOn={planStoppedOn}
                families={whatsappPaymentPlans}
                toggleDialog={() => toggleDialog("ChangeWhatsappPaymentsPlan")}
                familyType={"ChangeWhatsappPaymentsPlan"}
                isWhatsappVerified={isWhatsappVerified}
                classes={classes}
                hasWriteAccess={hasWriteAccess}
              />
            )}

            {/**
             * Credit Management
             */}
            <>
              <PlanColumn
                title={
                  partnerId === "62839c2733581a0fb5e71df6"
                    ? "PWC Credit"
                    : "WCC Credit"
                }
                color={isWhatsappVerified ? "#08CF65" : "#ff8c00"}
              />

              <PlanRow
                title={"Amount"}
                value={Number(
                  (partnerId === "62839c2733581a0fb5e71df6"
                    ? partnerWhatsappCredit || 0
                    : templateCredit || 0) / 100000
                ).toFixed(2)}
                showIcon={!planStoppedOn}
                handleClick={() =>
                  toggleDialog(
                    partnerId === "62839c2733581a0fb5e71df6"
                      ? "PwcCredit"
                      : "WccCredit"
                  )
                }
                hasWriteAccess={hasWriteAccess}
                Icon={<Edit />}
                classes={classes}
              />
            </>
            {META_ADS?.status === "active" &&
              (currency !== "USD" || adSetupDetails) && (
                <>
                  <PlanColumn
                    title={"Ad Credit"}
                    color={isWhatsappVerified ? "#08CF65" : "#ff8c00"}
                  />

                  <PlanRow
                    title={"Amount"}
                    value={Number((metaAdsCredit || 0) / 100000).toFixed(2)}
                    showIcon={!planStoppedOn}
                    handleClick={() => toggleDialog("adCredit")}
                    hasWriteAccess={hasWriteAccess}
                    Icon={<Edit />}
                    classes={classes}
                  />
                </>
              )}
          </>
        )}

        {/* Chargebee disclaimer text */}
        {chargebeePlan && (
          <Grid
            item
            xs={12}
            md={12}
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 10,
              alignItems: "center",
            }}
          >
            <Grid
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Box
                padding="10px 36px"
                style={{
                  background: "#f7ebffdb",
                  marginTop: 12,
                  borderRadius: "8px",
                }}
              >
                <Typography variant="h4">
                  This project's billing is being managed through ChargeBee
                </Typography>
              </Box>
            </Grid>
          </Grid>
        )}

        <Box mt={2} />
        {/* Settings */}
        <>
          <PlanColumn title={"Settings"} color={"#461486"} />
          <Box mt={2} />
          <PlanRow
            title={"Archive Project"}
            value={""}
            showIcon={true}
            handleClick={() => toggleDialog("DeleteProject")}
            Icon={<DeleteForever />}
            hasWriteAccess={hasWriteAccess}
            classes={classes}
          />
        </>

        <Box mt={2} />
        {/* Stop Plan */}
        {!chargebeePlan && (
          <Grid
            item
            xs={12}
            md={12}
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 10,
              alignItems: "center",
            }}
          >
            <Grid
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              {planStoppedOn ? (
                <>
                  <Box
                    padding="10px 36px"
                    style={{
                      background: "#f7ebffdb",
                      marginTop: 12,
                      borderRadius: "8px",
                    }}
                  >
                    {status !== "stopped" ? (
                      <Typography variant="h4">
                        This project was requested to be stopped on{" "}
                        <strong>{moment(planStoppedOn).format("LL")}</strong>{" "}
                        all the services of this project will be disabled on{" "}
                        <strong>{moment(planRenewalOn).format("LL")}</strong>
                      </Typography>
                    ) : (
                      <Typography variant="h4">
                        This project was stopped on{" "}
                        <strong>{moment(planStoppedOn).format("LL")}</strong>{" "}
                        all the services of this project are be disabled
                      </Typography>
                    )}
                  </Box>
                  <Button
                    color="primary"
                    onClick={() => toggleDialog("ReactivatePlan")}
                    style={{
                      marginTop: "12px",
                    }}
                    variant="contained"
                    disabled={loader || !hasWriteAccess}
                    endIcon={loader && <CircularProgress size={20} />}
                  >
                    Reactivate Plan
                  </Button>
                </>
              ) : (
                <>
                  <Typography variant="h4" color="primary">
                    Disable Plan
                  </Typography>
                  <Button
                    color="primary"
                    disabled={!hasWriteAccess}
                    onClick={() => toggleDialog("StopPlan")}
                    variant="contained"
                  >
                    Stop
                  </Button>
                </>
              )}
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
}

function UnverifiedProjectConfig(props) {
  const {
    deleteProject,
    classes,
    hasWriteAccess,
    assistant,
    toggleEmbeddedSignup,
    planStoppedOn,
    toggleDialog,
    partner,
    projectStatus,
  } = props;
  let { planRenewalOn, planActivatedOn } = assistant;
  planRenewalOn = moment(planRenewalOn).startOf("day");
  planActivatedOn = moment(planActivatedOn).startOf("day"); // difference in milliseconds
  const diffInDays = planRenewalOn.diff(planActivatedOn, "days");

  const { currency, metaAdsCredit } = assistant;
  const { enableMetaAdsWithoutAPI } = partner;

  return (
    <Box>
      {diffInDays == 7 && hasWriteAccess && (
        <>
          {" "}
          <PlanColumn title={"Toggle project status"} color={"#461486"} />
          <Box mt={2} />
          <PlanRow
            title={
              "Reinitiate Project to allow users to make their waba live after trial is expired"
            }
            value={projectStatus == "active" ? "Active" : "Stopped"}
            showIcon={true}
            handleClick={toggleEmbeddedSignup}
            Icon={<Edit />}
            classes={classes}
            hasWriteAccess={hasWriteAccess}
          />
        </>
      )}
      <PlanColumn title={"Settings"} color={"#461486"} />
      <Box mt={2} />
      <PlanRow
        title={"Archive Project"}
        value={""}
        showIcon={true}
        handleClick={deleteProject}
        Icon={<DeleteForever />}
        classes={classes}
        hasWriteAccess={hasWriteAccess}
      />
      {enableMetaAdsWithoutAPI && currency !== "USD" && (
        <>
          <PlanColumn title={"Ad Credit"} color={"#461486"} />

          <PlanRow
            title={"Amount"}
            value={Number((metaAdsCredit || 0) / 100000).toFixed(2)}
            showIcon={!planStoppedOn}
            handleClick={() => toggleDialog("adCredit")}
            hasWriteAccess={hasWriteAccess}
            Icon={<Edit />}
            classes={classes}
          />
        </>
      )}
      <Box mt={2} />
      <Box mt={4} textAlign="center">
        <Typography
          variant="body1"
          color="textSecondary"
          style={{ padding: 20 }}
        >
          Waba is not live yet!
        </Typography>
      </Box>
    </Box>
  );
}
